import React from "react";
import { Table, Group, Text, Box } from "@mantine/core";
import styles from "../../../project-management/components/ProjectsTable/ProjectsTable.module.css";
import { useGetLeavesRequest } from "api/leaveRequest/getLeaveRequest";
import { capitalizeFirstLetter } from "utils/capitalizeFirstLetter";

export default function ReviewTable() {
  const { data, isLoading, error, refetch } = useGetLeavesRequest();

  const leaveList = data?.data?.reviewed ?? [];

  return (
    <Box style={{ backgroundColor: "#fff", padding: 20, borderRadius: 8 }}>
      <div className={styles.container}>
        <Table
          withBorder
          className={styles.table}
          verticalSpacing="md"
          horizontalSpacing={20}
        >
          <thead>
            <tr>
              <th className={styles["name-column"]}>Employee Name</th>
              <th>Leave Type</th>
              <th>From</th>
              <th>To</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Reviewed BY</th>
            </tr>
          </thead>
          <tbody>
            {leaveList.map((leave) => (
              <tr key={leave._id}>
                <td>
                  <Group spacing="xs">
                    <Text>
                      {leave.user.firstName} {leave.user.lastName}
                    </Text>
                  </Group>
                </td>
                <td>
                  <Text>{leave.leaveType}</Text>
                </td>
                <td>
                  <Text>
                    {new Date(leave.fromDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </Text>
                </td>
                <td>
                  <Text>
                    {new Date(leave.toDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </Text>
                </td>
                <td>
                  <Text>{leave.reason}</Text>
                </td>
                <td>
                  <Text>{capitalizeFirstLetter(leave.status)}</Text>
                </td>
                <td>
                  <Group spacing="xs" display="flex">
                    <Text>
                      {leave.reviewedBy?.firstName} {leave.reviewedBy?.lastName}{" "}
                      <span>
                        {leave?.reviewedByReason &&
                          `(${leave?.reviewedByReason})`}
                      </span>
                    </Text>
                  </Group>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Box>
  );
}
